import * as React from "react";
import { t } from "../../i18n/util";
import { THEME } from "../../theme/ThemeStore";
import { pushRoute } from "../app/router/history";
import { Routes } from "../app/router/Routes";
import { HrBotButton } from "./Primitives";
import { HrRoutes } from "../hr/router/HrRoutes";
import { authStore } from "../../stores/AuthStore";

type Props = {
    errorCode: 404 | 505;
};

export const ErrorSite = ({ errorCode }: Props) => (
    <div
        style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            gap: 24
        }}
    >
        <img src={THEME.Images.illuPlanet} alt="" style={{ marginBottom: 26 }} />
        <h1 style={{ textAlign: "center" }}>
            {errorCode === 404 ? t("screen.notFound.404Error") : t("screen.internalError.505Error")}
        </h1>
        <p>{errorCode === 404 ? t("screen.notFound.title") : t("screen.internalError.title")}</p>
        <HrBotButton
            type="button"
            label={t("errorSite.returnBackHome")}
            onClick={() => pushRoute(authStore.isAuthenticated ? HrRoutes.DASHBOARD : Routes.APPLICATION)}
            style={{
                width: "auto"
            }}
        />
    </div>
);
